import React, { useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid} from 'recharts';
import dayjs from 'dayjs';

const Chart = ({fullData}) => {
  const timeframes = {'1W': 7, '1M': 30, '3M': 90, '6M': 180, '1Y': 365, 'ALL': null,};
  const [timeframe, setTimeframe] = useState('3M');

  const getChartData = () => {
    let filtered = timeframes[timeframe] === null
      ? fullData
      : fullData.filter(d =>
          dayjs(d.date).isAfter(dayjs().subtract(timeframes[timeframe], 'day'))
        );
    return filtered.sort((a, b) => new Date(a.date) - new Date(b.date));
  };

  const chartData = getChartData();

  const formatMillions = (value) => {
    if (value >= 1e6) return `${(value / 1e6).toFixed(2)}M`;
    if (value >= 1e3) return `${(value / 1e3).toFixed(2)}K`;
    return value.toFixed(2);
  };

  return (
    <div style={{
      width: "100%",
      backgroundColor: "#111",
      borderRadius: 12,
      padding: 10,
      color: "#fff",
      gap: 10,
      alignItems: "center",
      position: "relative",
      overflow: "hidden"
    }}>
      <div className='d-flex justify-content-end gap-2 flex-wrap mb-3'>
        <div className="d-flex justify-content-end flex-wrap gap-1">
          <div className="d-flex" style={{ marginBottom: 10 }}>
            <div className="rTabs">
              {Object.keys(timeframes).map(tf => (
                <button
                  key={tf}
                  onClick={() => setTimeframe(tf)}
                  style={{
                    marginRight: 8,
                    padding: '6px 12px',
                    background: timeframe === tf
                      ? 'radial-gradient(62.23% 424.31% at 68.62% 42.59%, #76EA10 0%, #2FCD3F 100%)'
                      : '',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 15,
                    cursor: 'pointer',
                    transition: '0.3s'
                  }}
                >
                  {tf}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      
      <div>
        <ResponsiveContainer width="100%" height={500}>
            <AreaChart data={chartData} margin={{ left: 0, right: 0 }}>
              <defs>
                <linearGradient id="colorUFO" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#97FB1D" stopOpacity={0.6} />
                  <stop offset="100%" stopColor="#121212" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="colorPulseX" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#d8ffa9" stopOpacity={0.6} />
                  <stop offset="100%" stopColor="#121212" stopOpacity={0} />
                </linearGradient>
              </defs>
              {/* Add Cartesian Grid */}
              <CartesianGrid stroke="#333" strokeDasharray="3 3" />
              <XAxis dataKey="date" tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={date => dayjs(date).format('DD MMM, YYYY')}/>
              <YAxis yAxisId="UFO" tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={formatMillions} label={{ value: 'UFO', angle: -90, position: 'insideLeft', fill: '#ccc', offset: 30, dy: -30}}/>
              <YAxis yAxisId="PULSEX" orientation="right" tick={{ fill: '#ccc', fontSize: 12 }} tickFormatter={formatMillions} label={{ value: 'PULSEX', angle: -90, position: 'insideRight', fill: '#ccc', offset: 25, dy: -85}}/>

              <Tooltip
                contentStyle={{ backgroundColor: '#333', border: 'none' }}
                labelStyle={{ color: '#fff' }}
                formatter={(value, name) => {
                  const labelMap = {
                    MarketCap: 'Market Cap',
                    Price: 'Price',
                    Volume: 'Volume'
                  };

                  let formattedValue = '$' + parseFloat(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                  return [formattedValue, labelMap[name] || name];
                }}
                labelFormatter={label => `Date: ${dayjs(label).format('DD MMM, YYYY')}`}
              />
              <Area yAxisId="UFO" type="monotone" dataKey="UFO" stroke="#97FB1D" fill="url(#colorUFO)" fillOpacity={1}/>
              <Area yAxisId="PULSEX" type="monotone" dataKey="PULSEX" stroke="#d8ffa9" fill="url(#colorPulseX)" fillOpacity={1}/>
            </AreaChart>
          </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;
